export const authEmailSelector = (state) => state.auth.email;
export const authUserIdSelector = (state) => state.auth.user_id;
export const authIsLoadingSelector = (state) => state.auth.isLoading;
export const authCurrencySelector = (state) => state.auth.currency;
